export const JORNADA_CONTEXT_PENDING_VALUE = "—";
export const JORNADA_CONTEXT_EMPTY_VALUE = "Sin dato";

const CONTEXT_KEYS = Object.freeze([
  "id",
  "idProyecto",
  "actividad",
  "estadoConvo",
  "municipio",
  "parroquia",
  "comunidad",
  "fecha",
  "descripcionConvo",
]);

export const normalizeLegacyCatalogId = (value) => {
  if (value === null || value === undefined) return "";
  return String(value).trim().replace(/^:+/, "");
};

export const sanitizeConvocatoriaContext = (source = {}) => {
  const candidate = {
    id: source.id ?? source.idConvocatoria,
    idProyecto: source.idProyecto ?? source.projectId,
    actividad: source.actividad,
    estadoConvo: source.estadoConvo,
    municipio: source.municipio,
    parroquia: source.parroquia,
    comunidad: source.comunidad,
    fecha: source.fecha,
    descripcionConvo: source.descripcionConvo ?? source.descripcion,
  };

  return CONTEXT_KEYS.reduce((context, key) => {
    context[key] = candidate[key];
    return context;
  }, {});
};

export const getValidConvocatoriaContext = (source, convocatoriaId) => {
  if (!source || typeof source !== "object") return null;
  const context = sanitizeConvocatoriaContext(source);
  const contextId = normalizeLegacyCatalogId(context.id);
  const routeId = normalizeLegacyCatalogId(convocatoriaId);
  return contextId && routeId && contextId === routeId ? context : null;
};

export const getSummaryConvocatoriaContext = (summary, convocatoriaId) => {
  const source = summary?.convocatoria;
  if (!source || normalizeLegacyCatalogId(source.estadoConvo) === "") return null;
  return getValidConvocatoriaContext(source, convocatoriaId);
};

export const findLegacyCatalogName = (items, id, idKey) => {
  const normalizedId = normalizeLegacyCatalogId(id);
  if (!normalizedId || !Array.isArray(items)) return "";
  const match = items.find(
    (item) => normalizeLegacyCatalogId(item?.[idKey]) === normalizedId
  );
  return typeof match?.nombre === "string" ? match.nombre.trim() : "";
};

export const toResolvedJornadaValue = (value) => {
  if (typeof value === "string" && value.trim()) return value.trim();
  if (typeof value === "number" && Number.isFinite(value)) return String(value);
  return JORNADA_CONTEXT_EMPTY_VALUE;
};
